/* eslint-disable @typescript-eslint/no-unused-vars */
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React, { useContext, useEffect, useState } from 'react';

import { Media } from '../../../contexts/media/MediaContext';
import { UiStateContext } from '../../../contexts/ui-state/UiStateContext';
import { HighImpactContainerHeroContent, IconPack } from '../../../models/app-data-model';
import ButtonWrapper from '../../button-wrapper/button-wrapper';
import ShIcon from '../../sh-icon/sh-icon';
import './high-impact-reduced-height-hero.scss';
import { corewellHeroOverrideClasses } from '../../../../constants/constants';

export type HeroContentProps = {
  content: HighImpactContainerHeroContent;
  iconPack: IconPack[];
  headerPresent?: boolean;
  corewellStyleOverrides?: boolean;
};

const HighImpactReducedHeightHero: React.FC<HeroContentProps> = ({ content, iconPack, headerPresent, corewellStyleOverrides }: HeroContentProps) => {
  const uiStateContext = useContext(UiStateContext);
  const noMarginTopClass = !headerPresent ? 'no-margin-top' : '';

  const [scrollToElement, setScrollToElement] = useState<HTMLDivElement>();

  useEffect(() => {
    if (typeof document !== 'undefined' && document.getElementById('high-impact-container')) {
      setScrollToElement(document.getElementById('scroll-to') as HTMLDivElement);
    }
  }, []);

  const posterImageDesktop = (
    <GatsbyImage
      className="hero-image-desktop"
      alt={content.image_desktop?.alt_text}
      image={content?.image_desktop?.file?.localAsset?.childImageSharp?.gatsbyImageData as IGatsbyImageData}
      objectPosition="top center"
    />
  );

  const posterImageMobile = (
    <GatsbyImage
      className="hero-image-mobile"
      alt={content.image_mobile?.alt_text}
      image={content?.image_mobile?.file?.localAsset?.childImageSharp?.gatsbyImageData as IGatsbyImageData}
    />
  );

  const lightFontMode = content.overlay_text_color?.color === 'light';

  const scrolldownBtnClasses = `scroll-down-btn ${lightFontMode ? '' : 'dark'} ${uiStateContext.pageHasScrolled ? 'fade-out' : 'fade-in'}`;

  const marginTopOverride = corewellStyleOverrides ? `${corewellHeroOverrideClasses?.heroMarginTopOverride}` : '';
  const reducedHeightContainerClasses = `high-impact-reduced-height-hero ${noMarginTopClass} ${marginTopOverride}`;

  return (
    <div className={reducedHeightContainerClasses} data-testid="high-impact-reduced-height-hero">
      <div className="hero-container" id="high-impact-container">
        <Media greaterThanOrEqual="tablet">{posterImageDesktop}</Media>
        <Media lessThan="tablet">{posterImageMobile}</Media>
        {content.header && (
          <h1 data-testid="hero-header" className="hidden xl-6">
            {content.header}
          </h1>
        )}
        {content?.call_to_action_button?.text && content?.call_to_action_button?.reference ? (
          <div className="cta-btn-container">
            <ButtonWrapper
              type={content?.call_to_action_button?.button_type ? content?.call_to_action_button?.button_type : 'primary'}
              styleOverride={'wide-button'}
              label={content?.call_to_action_button?.text}
              reference={content?.call_to_action_button?.reference}
              iconPack={iconPack}
            />
          </div>
        ) : !content?.hide_scroll_down_icon ? (
          <Media lessThan="tablet">
            {/* Only render this on mobile (INTSTAT-406) */}
            <button
              onClick={() => scrollToElement?.scrollIntoView({ behavior: 'smooth' })}
              className={`unstyled-btn ${scrolldownBtnClasses}`}
              id="scroll-down-btn"
              data-testid="scroll-down-btn"
            >
              <ShIcon iconPack={iconPack} iconName={lightFontMode ? 'white_arrow' : 'arrow'} className="scroll-down-icon" />
            </button>
          </Media>
        ) : null}
      </div>
      <div id="scroll-to" className="scroll-to"></div>
    </div>
  );
};

export default HighImpactReducedHeightHero;
